const Column = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
        <path stroke="currentColor" d="M4.5 20v-7m3 7V10m3 10V8m3 12V10m3 10v-8m3 8V10m3 10V8"></path>
    </svg>
}

export default Column